import { useEffect } from 'react';

import { useOnboardingStore } from '../model/onboarding-store';
import { TOUR_REGISTRY } from '../model/onboarding.constants';

/**
 * Skips onboarding for bugbug automated test sessions.
 * When ?bugbug=true is present in the URL, marks all tours
 * as dismissed via Zustand store so they won't appear on finalize stage.
 *
 * Uses getState() to read/write store without subscribing,
 * avoiding re-render loops and dependency issues.
 */
export function useBugbugOnboardingSkip() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('bugbug') !== 'true') return;

    const { setTourStates, tourStates } = useOnboardingStore.getState();
    const dismissed: Record<string, { dismissed: boolean }> = {};
    TOUR_REGISTRY.forEach((tour) => {
      dismissed[tour.id] = { dismissed: true };
    });

    // Update Zustand in-memory state (persist middleware will sync to localStorage)
    setTourStates({ ...tourStates, ...dismissed });
  }, []);
}
